import moment from 'moment'

import {
	getDateNow,
	getTimeNow,
	getTimeDifference,
	mergeFormattedDateTime
} from '@/utils/helpers'

export default {
	getExistingOrderingHours() {
		return (
			this.orderingHours &&
			this.orderingHours.length &&
			this.orderingHours.filter(item => !item.closed)
		)
	},

	checkIsAvailable(venueInfo) {
		this.venueInfo = venueInfo
		this.timeZone = venueInfo.timeZone
		this.orderingHours = venueInfo.orderingHours
		const { acceptOnlineOrder } = venueInfo
		const isOldVersion = !this.orderingHours.length

		if (isOldVersion) {
			return acceptOnlineOrder
		} else {
			const existingOrderingHours = this.getExistingOrderingHours()
			const hasExistingOrderingHours = !!existingOrderingHours.length
			const isPrevDayHoursEnabled = this.checkIsPrevDayHoursEnabled()
			const isCurDayHoursEnabled = this.checkIsCurDayHoursEnabled()

			return (
				hasExistingOrderingHours &&
				(isPrevDayHoursEnabled || isCurDayHoursEnabled)
			)
		}
	},

	// Remove from v.4.2
	// getDaysShift() {
	// 	const { weekStart } = this.venueInfo.businessDays
	//
	// 	if (!weekStart) {
	// 		return 0
	// 	} else {
	// 		return WEEK_DAYS.findIndex(day => {
	// 			return day.short.toLowerCase() === weekStart.toLowerCase()
	// 		})
	// 	}
	// },

	getIndexOfDow(date) {
		const nowDayIndex = date.day()
		let index = nowDayIndex + 1

		if (index > 7) {
			index -= 7
		} else if (index < 1) {
			index += 7
		}

		return index
	},

	getDayAllOrderingHours(indexOfDow) {
		let dayAllOrderingHours = this.orderingHours.filter(hoursObj => {
			return hoursObj.dow === indexOfDow && !hoursObj.closed
		})

		if (!dayAllOrderingHours) return []

		dayAllOrderingHours = dayAllOrderingHours.sort((dayA, dayB) => {
			return dayA.position - dayB.position
		})

		return dayAllOrderingHours
	},

	getDateTimeNow() {
		const nowDate = getDateNow(this.timeZone)
		const nowTime = getTimeNow(this.timeZone)

		return {
			nowDate,
			nowTime
		}
	},

	checkIsPrevDayHoursEnabled() {
		const { nowDate, nowTime } = this.getDateTimeNow()
		const previousBusinessDay = moment(nowDate).subtract(1, 'days')
		const indexOfDow = this.getIndexOfDow(previousBusinessDay)
		const dayAllOrderingHours = this.getDayAllOrderingHours(indexOfDow)

		if (!dayAllOrderingHours.length) return false

		const firstStartTime = dayAllOrderingHours[0].startTime

		for (let i = 0; i < dayAllOrderingHours.length; i++) {
			const { startTime, endTime } = dayAllOrderingHours[i]
			const isFirstDayStarts = getTimeDifference(firstStartTime, startTime) <= 0
			const isTransition = getTimeDifference(endTime, startTime) <= 0

			if (
				(isTransition && getTimeDifference(nowTime, endTime) <= 0) ||
				(!isFirstDayStarts &&
					getTimeDifference(nowTime, startTime) >= 0 &&
					getTimeDifference(nowTime, endTime) <= 0)
			) {
				return true
			}
		}

		return false
	},

	checkIsCurDayHoursEnabled() {
		const { nowDate, nowTime } = this.getDateTimeNow()
		const indexOfDow = this.getIndexOfDow(moment(nowDate))
		const dayAllOrderingHours = this.getDayAllOrderingHours(indexOfDow)

		if (!dayAllOrderingHours.length) return false

		const firstStartTime = dayAllOrderingHours[0].startTime

		for (let i = 0; i < dayAllOrderingHours.length; i++) {
			const { startTime, endTime } = dayAllOrderingHours[i]
			const isFirstDayStarts = getTimeDifference(firstStartTime, startTime) <= 0
			const isTransition = getTimeDifference(endTime, startTime) <= 0

			if (
				(isTransition && getTimeDifference(nowTime, startTime) >= 0) ||
				(isFirstDayStarts &&
					!isTransition &&
					getTimeDifference(nowTime, startTime) >= 0 &&
					getTimeDifference(nowTime, endTime) <= 0)
			) {
				return true
			}
		}

		return false
	},

	getNextAvailableTime() {
		const { nowDate } = this.getDateTimeNow()
		let nextDate = nowDate

		for (let i = 1; i <= 7; i++) {
			nextDate = moment(nextDate).add(1, 'day')
			const indexOfDow = this.getIndexOfDow(moment(nextDate))
			const dayAllOrderingHours = this.getDayAllOrderingHours(indexOfDow)

			if (!dayAllOrderingHours.length) continue

			const firstTime = dayAllOrderingHours[0].startTime
			const secondTime =
				dayAllOrderingHours[dayAllOrderingHours.length - 1].endTime

			if (firstTime && secondTime) {
				const startTime = mergeFormattedDateTime(
					nextDate,
					firstTime,
					this.timeZone
				)
				const endTime = mergeFormattedDateTime(
					nextDate,
					secondTime,
					this.timeZone
				)

				return { startTime, endTime }
			}
		}
	}
}
